<template>
    <div style="height: 100%;width: 100%;display: block;overflow:auto;">
        <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack"/>
        <el-tabs stretch v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="聊天记录" name="first">
                <el-timeline class="logcard">
                    <van-list v-model="loading" :finished="finished" finished-text="已经全部加载完成" @load="onLoad" style="width: 90%;">
                        <el-timeline-item :timestamp="item.accountdate" placement="top" v-for="(item,key) in beautyVos" :key="key">
                            <el-card v-if="(item.beautyXfLogs!=null && item.beautyXfLogs.length>0) || item.beautySaleLog!=null">
                                <el-divider v-if="item.beautyXfLogs!=null && item.beautyXfLogs.length>0">消耗</el-divider>
                                <div v-if="item.beautyXfLogs!=null && item.beautyXfLogs.length>0" v-for="(val,index) in item.beautyXfLogs" :key="index">
                                  <p>门店:<span style="color:#409eff">{{val.storename}}</span></p>
                                  <p>消耗项目:<span style="color:#409eff">{{val.projectname}}</span></p>
                                  <p>服务日志:<span style="color:#409eff">{{val.chat}}</span></p>
                                </div>
                              <el-divider v-if="item.beautySaleLogs!=null && item.beautySaleLogs.length>0">销售</el-divider>
                              <div v-if="item.beautySaleLogs!=null && item.beautySaleLogs.length>0" v-for="(sale,index) in item.beautySaleLogs" :key="index">
                                <p v-if="sale!=null && sale.storename!=null && sale.storename!=''">
                                  门店:<span style="color:#409eff">{{sale.storename}}</span>
                                </p>
                                  <p v-if="sale!=null && sale.projectname!=null && sale.projectname!=''">
                                      购买项目:<span style="color:#409eff">{{sale.projectname}}</span>
                                  </p>
                                  <!--<p v-if="item.beautySaleLog!=null && item.beautySaleLog.connected!=null && item.beautySaleLog.connected!=''">销售时沟通细节:{{item.beautySaleLog.connected}}</p>-->
                                  <p v-if="sale!=null && sale.programme!=null && sale.programme!=''">
                                      具体方案赠送等:<span style="color:#409eff">{{sale.programme}}</span></p>
                              </div>
                              <p v-if="item.fileList!=null && item.fileList.length>0">
                                照片:<br>
                                <van-uploader :file-list="item.fileList" :deletable="false" :show-upload="false"/>
                              </p>
                                <!--<p v-if="item.beautySaleLog!=null && item.beautySaleLog.bedding!=null && item.beautySaleLog.bedding!=''">销售时铺垫了什么项目:{{item.beautySaleLog.bedding}}</p>-->
                            </el-card>
                        </el-timeline-item>
                    </van-list>
                </el-timeline>
            </el-tab-pane>
            <el-tab-pane label="课程注意" name="second">
                <div style="width: 100%;text-align: center;">
                    <el-switch v-model="flag" active-text="剩余疗程" inactive-text="所有疗程"></el-switch>
                </div>
                <el-descriptions direction="vertical" :column="1" border style="margin-top: 10px;">
                    <el-descriptions-item :label="item.projectname" v-for="(item,key) in projectPoints" :key="key">
                      <p>注意事项:<span style="color:#409eff">{{item.details}}</span></p>
                      <p>为什么购买:<span style="color:#409eff">{{item.whybuy}}</span></p>
                    </el-descriptions-item>
                </el-descriptions>
            </el-tab-pane>
            <el-tab-pane label="服务注意" name="three" style="padding: 10px;">
                <el-form class="beautyserver">
                    <el-form-item label="是否接受回访:">
                        <span v-if="beautyServer.returnVisit==1" style="color:#409eff">接受</span>
                        <span v-if="beautyServer.returnVisit==2" style="color:#409eff">不接受</span>
                    </el-form-item>
                    <el-form-item label="当下客户的满意度:">
                        <span v-if="beautyServer.grade==1" style="color:#409eff">一般</span>
                        <span v-if="beautyServer.grade==2" style="color:#409eff">满意</span>
                        <span v-if="beautyServer.grade==3" style="color:#409eff">不满意</span>
                        <span v-if="beautyServer.grade==4" style="color:#409eff">很满意</span>
                    </el-form-item>
                    <el-form-item label="目前有什么不满意的状态:">
                      <span style="color:#409eff">{{beautyServer.dissatisfied}}</span>
                    </el-form-item>
                    <el-form-item label="喜欢喝什么饮料:">
                        <span style="color:#409eff">{{beautyServer.drinks}}</span>
                    </el-form-item>
                    <el-form-item label="喜欢吃什么水果:">
                        <span style="color:#409eff">{{beautyServer.fruits}}</span>
                    </el-form-item>
                    <el-form-item label="喜欢吃什么食物:">
                        <span style="color:#409eff">{{beautyServer.food}}</span>
                    </el-form-item>
                    <el-form-item label="性格:">
                        <span style="color:#409eff">{{beautyServer.characters}}</span>
                    </el-form-item>
                    <el-form-item label="喜欢聊天的内容:">
                        <span style="color:#409eff">{{beautyServer.chat}}</span>
                    </el-form-item>
                    <el-form-item label="不能聊什么:">
                        <span style="color:#409eff">{{beautyServer.nochat}}</span>
                    </el-form-item>
                    <!--<el-form-item label="与客户的聊天记录">
                        <el-input type="textarea" v-model="beautyServer.chatlog" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                    </el-form-item>-->
                    <el-form-item label="客户讲的比较重要的话:">
                        <span style="color:#409eff">{{beautyServer.importantchat}}</span>
                    </el-form-item>
                    <!--<el-form-item label="客情记录送什么时间送过什么">
                        <el-input type="textarea" v-model="beautyServer.givelog" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                    </el-form-item>-->
                </el-form>
            </el-tab-pane>
          </el-tabs>

    </div>
</template>
<script>
    export default {
        data() {
            return {
                activeName:"first",
                storeid:localStorage.getItem("storeid"),
                memberid:"",
                cardid:"",
                loading:false,
                finished:false,
                beautyVos:[],
                curPage:1,
                projectPoints:[],
                flag:true,
                beautyServer:{},
            }
        },
        created: function () {
            this.cardid=this.$route.query.cardid;
            this.memberid=this.$route.query.memberid;
            this.getBeautySalelogAndXflog();
        },
        methods: {
            getBeautyServerById(){
                this.$post("beautymanager/getBeautyServerById",{storeid:this.storeid,memberid:this.memberid}).then(res=>{
                    if(res.sucess){
                        this.beautyServer=res.object;
                        if(this.beautyServer==null){
                            this.beautyServer={};
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getCardCourseByProjectPoints(){
                let type=1;
                if(this.flag==false){
                    type=2;
                }
                this.$post("beautymanager/getCardCourseByProjectPoints",{storeid:this.storeid,cardid:this.cardid,type:type}).then(res=>{
                    if(res.sucess){
                        this.projectPoints=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            handleClick(){
                if(this.activeName=="second"){
                    this.getCardCourseByProjectPoints();
                }
                else if(this.activeName=="three"){
                    this.getBeautyServerById();
                }
            },
            onLoad(){
                this.curPage++;
                this.getBeautySalelogAndXflog();
            },
            getBeautySalelogAndXflog(){
                this.loading=true;
                this.$post("beautymanager/getBeautySalelogAndXflog",{storeid:this.storeid,cardid:this.cardid,curPage:this.curPage}).then(res=>{
                    this.loading=false;
                    if(res.sucess){
                        let obj=res.object;
                        if(obj!=null && obj.length>0){
                            for(let val of obj){
                                this.beautyVos.push(val);
                            }
                        }
                        else{
                            this.finished=true;
                        }
                    }
                    else{
                        this.finished=true;
                        this.$message.error(res.message);
                    }
                });
            }
        }
    }
</script>

<style style lang="scss" rel="stylesheet/scss">
    .logcard .el-card__body{
        padding: 0px 20px;
    }
    .beautyserver .el-form-item{
      margin-bottom:0px;
    }
</style>



// WEBPACK FOOTER //
// src/page/beauty/beautylog.vue